var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indextitle"},[_c('div',{staticClass:"title"},[_c('a',{staticClass:"active",attrs:{"href":"javascript:void(0);"}},[_c('p',{staticClass:"name"},[_vm._t("title")],2),_c('span',[_c('p',[_vm._t("eng")],2)])])]),_c('div',{staticClass:"more"},[_vm._t("more")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }